"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCustomerAccountTextLinkClick = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackCustomerAccountTextLinkClick(clickText, clickElement, clickUrl) {
    const eventData = {
        eventName: enums_1.GA4EventName.ClickTextLink,
        feature_category: enums_1.GA4FeatureCategory.CustomerAccount,
        click_element: clickElement,
        click_text: clickText,
        click_url: clickUrl,
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)(eventData);
}
exports.trackCustomerAccountTextLinkClick = trackCustomerAccountTextLinkClick;
//# sourceMappingURL=trackCustomerAccountTextLinkClick.js.map